import React, { useEffect, useState } from "react";
import { Formik, FormikConsumer, useFormik } from "formik";
// import * as Yup from "yup";
import {
  TextField,
  Button,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
  Box,
  Autocomplete,
} from "@mui/material";
import "bootstrap/dist/css/bootstrap.min.css";
import Card from "../../../components/common/Card";
import { addFuelPurchase, GetFuelDetails } from "../../../services/FuelService";
import { toast } from "react-toastify";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import {
  getShiftDetails1,
  getSiteDetails,
  getVendorDetails,
  saveDriverDetails,
  saveVehicleDetails,
  saveVendorDetails,
  vehicleTypes,
} from "../../../services/vehicleService";
import moment from "moment";
import axios from "axios";
const AddDriverManagement = () => {
  const [fuelList, setFuelList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [activeTab, setActiveTab] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [frequencyList, setFrequency] = useState([
    "Hourly",
    "Daily",
    "Monthly",
  ]);

  const [vendorList, setVendorList] = useState([]);
  const [key, setKey] = useState(Math.random());
  // const  []
  const formik = useFormik({
    initialValues: {
      vehicleTypeId: null,
      vehicleState: null,
      driverName: "",
      address: "",
      contactNo: "",
      aadharNo: "",
      licenseFile: null,
      license: "",
      documentType: null,
      document: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    onSubmit: async (values) => {
      let obj = values;
      console.log(obj);
      let formdata = new FormData();
      // delete obj["vehicleState"];
      Object.keys(values).forEach((element) => {
        if (values[element]) {
          if (!element.includes("State")) {
            formdata.append(element, values[element]);
          }
        }
      });
      console.log(formdata);
      console.log(formik.values);

      //Loading.
      await saveDriverDetails(formdata).then((res) => {
        if (res) {
          if (res.data.statusDescription.statusCode == 200) {
            toast.success(res.data.statusDescription.description);
            let e;
            formik.handleReset(e);
            setKey(Math.random());
            document.getElementById("sdhbfgvsdyfgs")?.click();
          } else {
            toast.warn(res.data.statusDescription.description);
          }
        }
      });
    },
  });
  useEffect(() => {
    getAllDetails();
  }, []);

  const getAllDetails = async () => {
    setKey(Math.random());
    getVehiclees();
  };

  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setVehicleList(res.data.data);

          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(res.data.data[0].name);
            setActiveId(res.data.data[0].vehicleTypeId);
          }
        } else {
        }
      })
    );
  };

  return (
    <Card title={"Add Driver"}>
      <Box className="container mt-4">
        <form onSubmit={formik.handleSubmit} className="mt-4">
          {/* <div className="row mb-2">
            <div className="col-md-4 col-12  mb-2">
              <Autocomplete
                options={sitesList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.siteIdState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.siteName || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("siteIdState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("siteIdState", newValue);
                    console.log(newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Sites`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={shiftList || []}
                size="small"
                className="inp_search"
                label={"Site"}
                multiple
                // sx={{ width: 300 }}
                value={formik.values.shiftState || []}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("shiftState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("shiftState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Shift`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vendorList || []}
                size="small"
                className="inp_search"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vendorState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vendorState", newValue);
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vendorState", newValue);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Search Vendor`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>
          </div> */}

          <div className="row mb-2">
            <div className="col-md-4 col-12 mb-2">
              <Autocomplete
                options={vehicleList || []}
                size="small"
                className="inp_search1"
                label={"Vendor"}
                // sx={{ width: 300 }}
                value={formik.values.vehicleState || null}
                style={{ padding: "2px", fontSize: "10px" }}
                getOptionLabel={(option) => option?.name || ""}
                onChange={(e, newValue, reason) => {
                  console.log(e.target.value);
                  if (reason == "clear") {
                    formik.setFieldValue("vehicleState", newValue);
                    formik.setFieldValue(
                      "vehicleTypeId",
                      newValue.vehicleTypeId
                    );
                  }

                  console.log(newValue);

                  if (newValue) {
                    formik.setFieldValue("vehicleState", newValue);
                    formik.setFieldValue(
                      "vehicleTypeId",
                      newValue.vehicleTypeId
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={`Vehicle Type`}
                    required
                    InputLabelProps={{
                      style: { fontSize: "12px" }, // Change label font size
                    }}
                    size="small"
                  />
                )}
              />
            </div>

            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Driver Name"
                name="driverName"
                size="small"
                value={formik.values.driverName}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.driverName && Boolean(formik.errors.driverName)
                }
                helperText={
                  formik.touched.driverName && formik.errors.driverName
                }
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Address "
                name="address"
                size="small"
                value={formik.values.address}
                onChange={formik.handleChange}
                required
                error={formik.touched.address && Boolean(formik.errors.address)}
                helperText={formik.touched.address && formik.errors.address}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Contact No"
                name="contactNo"
                size="small"
                value={formik.values.contactNo}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.contactNo && Boolean(formik.errors.contactNo)
                }
                helperText={formik.touched.contactNo && formik.errors.contactNo}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Aadhar Number"
                name="aadharNo"
                size="small"
                value={formik.values.aadharNo}
                onChange={formik.handleChange}
                required
                error={
                  formik.touched.aadharNo && Boolean(formik.errors.aadharNo)
                }
                helperText={formik.touched.aadharNo && formik.errors.aadharNo}
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="License"
                name="license"
                size="small"
                // value={formik.values.license || ""}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  let file = e.target.files[0];
                  console.log(file);
                  formik.setFieldValue("license", file?.name);
                  formik.setFieldValue("licenseFile", file);
                }}
                type="file"
                required
              />
            </div>
            <div className="col-md-4 col-12 mb-2">
              <TextField
                fullWidth
                label="Document Type"
                name="document"
                size="small"
                // value={formik.values.document || ""}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => {
                  let file = e.target.files[0];
                  formik.setFieldValue("document", file?.name);
                  formik.setFieldValue("documentType", file);
                }}
                type="file"
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-end d-flex justify-content-end">
              <Button
                type="reset"
                onClick={(e) => {
                  formik.handleReset(e);
                }}
                variant="contained"
                id="sdhbfgvsdyfgs"
                className="clr_btn me-3"
                color="secondary"
              >
                Clear
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="yellow_btn_1"
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </Box>
    </Card>
  );
};

export default AddDriverManagement;
